export default __webpack_public_path__ + "static/media/background.5e571875.png";